import * as types from "./types";
import * as authTypes from "../auth/types";
import { UIState } from "./interface";
import { UIInitialState } from "./initialState";

export default function reducer(state: UIState = UIInitialState, action: any) {
	switch (action.type) {
		case types.GET_DASHBOARD_INFO_START: {
			return {
				...state,
				isLoading: true,
			};
		}
		case types.GET_DASHBOARD_INFO_SUCCESS: {
			return {
				...state,
				isLoading: false,
				dashboard: action.payload,
				recipient: action.payload.recipient,
			};
		}
		case types.UPDATE_RECIPIENT_START: {
			return {
				...state,
				isLoading: true,
			};
		}
		case types.UPDATE_RECIPIENT_SUCCESS: {
			return {
				...state,
				isLoading: false,
				recipient: {
					...state.recipient,
					...action.payload.recipient,
				},
			};
		}

		case types.GET_CERTIFICATES_START: {
			return {
				...state,
				// isLoading: true,
			};
		}
		case types.GET_CERTIFICATES_SUCCESS: {
			return {
				...state,
				isLoading: false,
				certificates: action.payload,
			};
		}

		// case types.GET_COMMUNICATIONS_START: {
		// 	return {
		// 		...state,
		// 		isLoading: true,
		// 	};
		// }
		// case types.GET_COMMUNICATIONS_SUCCESS: {
		// 	return {
		// 		...state,
		// 		isLoading: false,
		// 		communications: action.payload,
		// 	};
		// }
		// case types.GET_DASHBOARD_INFO_ERROR: {
		//   return {
		//     ...state,
		//     isLoading: false,
		//     toasts: [...state.toasts, {
		//       id: state.toasts.length,
		//       message: "Could not load dashboard information",
		//       type: 'error'
		//     }]
		//   };
		// }

		case types.SET_WIZZARD_ACTIVE_STEP: {
			return {
				...state,
				wizzardActiveStep: action.payload,
			};
		}

		case types.ADD_TOAST: {
			const id = state.toasts.length;
			return {
				...state,
				toasts: [...state.toasts, { id: id, ...action.payload }],
			};
		}
		case types.CLEAR_TOASTS: {
			const id = state.toasts.length;
			return {
				...state,
				toasts: [],
			};
		}
		case types.REMOVE_TOAST: {
			return {
				...state,
				toasts: state.toasts.filter((toast) => toast.id !== action.payload),
			};
		}
		case authTypes.GET_ISSUER_ERROR: {
			return {
				...state,
				// toasts: [
				// 	...state.toasts,
				// 	{
				// 		id: state.toasts.length,
				// 		message: "Could not load issuer data",
				// 		type: "error",
				// 	},
				// ],
			};
		}

		default: {
			return state;
		}
	}
}
